import React from 'react';

export type StepperItem = {
  label: React.ReactNode;
  status?: 'active' | 'done' | 'pending';
};

export type StepperProps = {
  steps: StepperItem[];
  className?: string;
};

export const Stepper: React.FC<StepperProps> = ({ steps, className = '' }) => (
  <div className={`stepper ${className}`}>
    {steps.map((s, i) => (
      <React.Fragment key={i}>
        <div className={`step ${s.status ?? 'pending'}`}>
          <span className="step-num">{s.status === 'done' ? '\u2713' : i + 1}</span>
          <span style={{ fontSize: 13, fontWeight: 500 }}>{s.label}</span>
        </div>
        {i < steps.length - 1 && <div className="step-line" />}
      </React.Fragment>
    ))}
  </div>
);
